var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('auth-button',{staticClass:"o-playlist__button o-like",class:{'o-like--unlike': _vm.isLiked},on:{"click":_vm.toggleLike}},[_c('SvgIcon',{staticClass:"o-playlist__icon",attrs:{"icon":"heart","aria-hidden":"true"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }